BX.Vue.component('aos__final',
    {
        computed: {
            title: (vm) => vm.$parent.msg('A_AOS_FINAL_TITLE'),
            text: (vm) => vm.$parent.msg('A_AOS_FINAL_TEXT'),
        },
        mounted: function () {
            let vm = this;
            vm.$parent.title = vm.title;
            document.body.classList.remove('-hide');
            document.body.classList.add('-final');
            vm.$parent.aos.classList.add('aos__final');
            vm.$parent.theme = 'dark';
            vm.$parent.removeMessageError();
            vm.$parent.scrollToElement('._aos', 0);
        },
        template: `<div class="ocf__section-text t2" v-html="text"/>`,
    }
);